import { render } from "./Livescorings.vue?vue&type=template&id=551e1496&scoped=true"
import script from "./Livescorings.vue?vue&type=script&lang=js"
export * from "./Livescorings.vue?vue&type=script&lang=js"

import "./Livescorings.vue?vue&type=style&index=0&id=551e1496&scoped=true&lang=css"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551e1496"]])

export default __exports__